import {
  createAll,
  Button,
  Checkboxes,
  ErrorSummary,
  Radios,
  ServiceNavigation,
  SkipLink
} from 'govuk-frontend'

import { initAll } from '@defra/forms-engine-plugin/shared.js'

createAll(Button)
createAll(Checkboxes)
createAll(ErrorSummary)
createAll(Radios)
createAll(ServiceNavigation)
createAll(SkipLink)

initAll()

// Print buttons (check-your-answers, application-sent) ship hidden because
// printing needs JS. The data guard keeps a second bundle from double-binding.
for (const button of document.querySelectorAll('[data-print-page]')) {
  if (!button.dataset.printBound) {
    button.dataset.printBound = 'true'
    button.removeAttribute('hidden')
    button.addEventListener('click', () => window.print())
  }
}
